<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
          <v-card-title class="text-h5 blue darken-3 white--text">
            Completar los datos
          </v-card-title>
  
          <v-card-text>   
            <p class="red--text">
              Los campos con * son obligatorios
            </p>
              <v-text-field label="*Fecha de ingreso:" v-model="fecha_ingreso"  type="date" prefix="el:" hide-details />
              <v-text-field label="*Nacionalidad:" v-model="nacionalidad" hide-details />
              <v-text-field label="*Provincia:" v-model="provincia" hide-details />
              <v-text-field label="Pasaporte:" v-model="pasaporte" hide-details />
              <v-text-field label="Grado academico:" v-model="grado" hide-details />
              <v-text-field label="Canton:" v-model="canton" hide-details />
              <v-text-field label="Distrito:" v-model="distrito" hide-details />
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" outlined @click="enviar()"> Aceptar </v-btn>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>

export default {
    data() {
        return { 
            dialog: false,
            pasaporte: '', 
            nacionalidad: '', 
            provincia: '', 
            canton: '', 
            distrito: '', 
            grado: '', 
            fecha_ingreso: {}, 
            resolvePromise: null,
        };
    },
    methods: {
        async openmodal(p) { 
          this.proy = p
          this.dialog = true; 
          this.pasaporte = p.estudiante.num_doc
          this.hoy()
          return new Promise((resolve) => {
              this.resolvePromise = resolve;
          });
        },
        hoy(){
          const fechaActual = new Date(); 
          const año = fechaActual.getFullYear();
          const mes = String(fechaActual.getMonth() + 1).padStart(2, '0'); 
          const dia = String(fechaActual.getDate()).padStart(2, '0'); 
          const fechaFormateada = `${año}-${mes}-${dia}`;
          this.fecha_ingreso = fechaFormateada;
        }, 

        cerrar(){
          this.resolvePromise(false);
          this.dialog = false;
        },
        enviar(){ 
            if(!this.fecha_ingreso) return 
            if(!this.nacionalidad) return 
            if(!this.provincia) return 
            const fs = this.fecha_ingreso.split('-')
            const input = {
                fecha_ingreso: `${fs[2]} / ${fs[1]} / ${fs[0]}`,
                nacionalidad: this.nacionalidad,
                canton: this.canton,
                distrito: this.distrito,
                provincia: this.provincia,
                grado: this.grado,
                pasaporte: this.pasaporte,
            }
            this.resolvePromise(input);
            this.dialog = false;
        }
    }
};
</script>
  